import { NextPage, NextPageContext } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import AboutComponent from "@containers/About";
import { canonicalLink } from "@helpers/url";
import { getProductMenu } from "@libraries/api/product-menu/product-menu.repos";
import { TProductIconData } from "@layouts/Main/lib/Header/lib/MenuProduct/type";
import { localeKey } from "@constants/locale-key";

const assetUrl = process.env.NEXT_PUBLIC_BASE_URL_ASSETS as string;

export interface IPropsPageTentangKami {
  dataNavbar: Array<TProductIconData>;
  lang?: string;
}

const About: NextPage<IPropsPageTentangKami> = ({ dataNavbar }) => {
  return (
    <AboutComponent dataNavbar={dataNavbar} />
  );
};

export async function getServerSideProps({ locale }: NextPageContext) {
  const lang = `${locale}`;
  const EN = lang === "en";
  const { data: dataProductMenu } = await getProductMenu({ level: 0 }, lang);
  return {
    props: {
      ...(await serverSideTranslations(`${locale}`, localeKey)),
      title: EN ? "About MyTEnS" : "Tentang MyTEnS",
      description: EN
        ? "MyTENs is committed to providing the best. Learn more about us here"
        : "MyTEns berkomitmen memberikan yang terbaik. Pelajari  lebih lanjut mengenai kami di sini",
      imageUrl: assetUrl + "/img_banner_about.jpg",
      canonical: canonicalLink(`/tentang-kami`, locale),
      dataNavbar: dataProductMenu,
    },
  };
}

export default About;
